import { jsx as r, jsxs as i } from "react/jsx-runtime";
import v from "react";
import { useTranslation as w } from "react-i18next";
import { useCurrentStage as x, useCurrentForm as A } from "@perxis-auto/trade-in-sdk";
import { Button as s } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row as d, Col as o } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Icon as a } from "@perxis-auto/ui-kit/lib/components/Icon";
import { Typography as k } from "@perxis-auto/ui-kit/lib/components/Typography";
import { APP as E } from "../../../shared/config/app.js";
import { APP_EVENTS as l, APP_EVENT_BUTTONS as f } from "../../../shared/config/events.js";
import { useAppContext as P } from "../../../shared/lib/app/context/appContext.js";
import { eventService as p } from "../../../shared/lib/event/eventService.js";
import { Field as B } from "../../../widgets/Field/ui/Field.js";
import { Form as N } from "../../../widgets/Form/ui/Form.js";
import { GET_FORWARD_BUTTON_TEXT_MAP as S } from "../lib/config/index.js";
function X() {
  const {
    current: t,
    data: e,
    actions: { setCurrent: c }
  } = x(), { prevStage: m } = P(), { t: n } = w(E.name), T = A(), _ = () => {
    m && (c(m.id), p.sendEvent(l.ButtonClicked, { id: f.BACK }));
  };
  if (e)
    return /* @__PURE__ */ r(N, { formId: e.form.id, schema: e.form, children: ({ isFailed: C, isDirty: y }) => {
      const h = !y && (C || !!T.error) && !!e.form.error_message;
      return /* @__PURE__ */ i(d, { gutter: [0, "vertical-yellow"], children: [
        /* @__PURE__ */ r(o, { span: 24, children: /* @__PURE__ */ i(d, { gutter: [16, "vertical-green"], children: [
          e.form.groups.map((u) => /* @__PURE__ */ r(v.Fragment, { children: u.fields.map((g) => /* @__PURE__ */ r(o, { xs: 24, sm: 12, children: /* @__PURE__ */ r(B, { fieldId: g.id, formId: e.form.id }) }, g.id)) }, u.id)),
          !!e.go_to && /* @__PURE__ */ r(o, { span: 24, children: /* @__PURE__ */ r(
            k.Link,
            {
              level: "main",
              color: "dark",
              onClick: () => {
                c(e.go_to), p.sendEvent(l.ButtonClicked, { id: f.FILL_MANUALLY });
              },
              children: n("stage.goTo")
            }
          ) }),
          h && /* @__PURE__ */ r(o, { span: 24, className: "pa-trade-in-error", children: /* @__PURE__ */ i(k.Paragraph, { className: "pa-trade-in-error__message", color: "light-colorful", level: "main", children: [
            /* @__PURE__ */ r(
              a,
              {
                size: 36,
                name: "warning",
                className: "pa-trade-in-error__icon",
                sticker: "trade-in-instock-warning-icon"
              }
            ),
            e.form.error_message
          ] }) })
        ] }) }),
        /* @__PURE__ */ r(o, { span: 24, children: /* @__PURE__ */ i(d, { gutter: [16, "vertical-sky"], children: [
          !!m && /* @__PURE__ */ r(o, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: /* @__PURE__ */ r(
            s,
            {
              htmlType: "button",
              type: "ghost",
              icon: /* @__PURE__ */ r(a, { name: "back", sticker: "trade-in-instock-back-icon" }),
              iconPosition: "left",
              onClick: _,
              children: n("stage.back")
            }
          ) }),
          /* @__PURE__ */ r(o, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: h ? /* @__PURE__ */ r(
            s,
            {
              htmlType: "button",
              type: "primary",
              icon: /* @__PURE__ */ r(a, { name: "forward", sticker: "trade-in-instock-forward-icon" }),
              onClick: () => c(e.error),
              children: n("stage.forward.default")
            }
          ) : /* @__PURE__ */ r(
            s,
            {
              htmlType: "submit",
              type: "primary",
              icon: /* @__PURE__ */ r(a, { name: "forward", sticker: "trade-in-instock-forward-icon" }),
              onClick: () => {
                t && p.sendEvent(l.ButtonClicked, {
                  id: f.CALCULATE_COST,
                  stage: t
                });
              },
              children: !!t && S(t) || n("stage.forward.default")
            }
          ) })
        ] }) })
      ] });
    } }, e.form.id);
}
export {
  X as Stage
};
